<template>
  <div class="block">
    <img v-if="surfcent" class="block__icon" src="@icons/currency.svg" alt="currency">
    <input
        :placeholder="placeholder"
        :type="isPasswordVisible"
        :value="modelValue"
        @input="onInput"
        class="block__input"
    >
    <button
      @click.prevent="setPasswordVisible"
      class="block__eyes"
      v-if="type === 'password'"
    >
      <img v-if="isPasswordVisible === 'password'" src="@icons/eyeClosed.svg" alt="eye">
      <img v-else src="@icons/eyeOpened.svg" alt="eye">
    </button>
    <p v-if="!validate" class="block__error">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import {ref} from "vue";

const $emit = defineEmits()
const props = defineProps({
  type: String,
  surfcent: Boolean,
  placeholder: String,
  isError: Boolean,
  error: String,
  modelValue: [String, Number],
  rules: Array
})

const isPasswordVisible = ref(props.type)
const setPasswordVisible = () => {
  if (isPasswordVisible.value === 'password') {
    isPasswordVisible.value = 'text'
    return
  }
  isPasswordVisible.value = 'password'
}

const validate = ref(true)
const errorMessage = ref('')
const onInput = (e) => {
  let result = true

  props.rules?.forEach((rule) => {
    result = rule((e.target).value)

    if (result !== true) {
      errorMessage.value = String(result)
      result = false
    }
  })

  validate.value = result

  return $emit('update:modelValue', (e.target).value)
}
</script>

<style lang="scss" scoped>
.block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  position: relative;

  &__icon {
    position: absolute;
    left: 7px;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
  }

  &__input {
    width: 100%;
    padding: 8px 15px;
    border-radius: 8px;
    border: 1px solid #AB3294;
    background-color: #F5F5F5;

    color: #5B194F;
    font-size: 16px;
    font-weight: 500;

    &::placeholder {
      color: #9ba1b4;
    }
  }

  &__eyes {
    cursor: pointer;
    position: absolute;
    right: 23px;
    top: 10px;
    background-color: transparent;
    display: grid;
    place-items: center;
  }

  &__error {
    color: $error;
    font-size: 12px;
    font-weight: 500;
    animation: fadeInUp 0.3s ease;

    @keyframes fadeInUp {
      0% {
        opacity: 0;
        transform: translateY(-50%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}
</style>